(() => {
  const playerStore = new WeakMap();
  let youtubeApiPromise;

  const loadYouTubeApi = () => {
    if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
    if (youtubeApiPromise) return youtubeApiPromise;

    youtubeApiPromise = new Promise((resolve) => {
      const previousReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (typeof previousReady === 'function') previousReady();
        resolve(window.YT);
      };

      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.head.appendChild(script);
      }
    });

    return youtubeApiPromise;
  };

  const resetVideo = (section) => {
    section.classList.remove('is-loading', 'is-playing');
    const nativeVideo = section.querySelector('.custom-powerdeck-video__native');
    if (nativeVideo) {
      nativeVideo.pause();
      nativeVideo.currentTime = 0;
    }

    const player = playerStore.get(section);
    if (player && typeof player.destroy === 'function') player.destroy();
    playerStore.delete(section);
    const youtubeContainer = section.querySelector('.custom-powerdeck-video__youtube');
    if (youtubeContainer) youtubeContainer.replaceChildren();
  };

  const initializeSection = (section) => {
    if (section.dataset.powerdeckVideoInitialized === 'true') return;
    section.dataset.powerdeckVideoInitialized = 'true';

    const playButton = section.querySelector('.custom-powerdeck-video__play');
    if (!playButton) return;

    const nativeVideo = section.querySelector('.custom-powerdeck-video__native');
    if (nativeVideo) nativeVideo.addEventListener('ended', () => resetVideo(section));

    playButton.addEventListener('click', async () => {
      if (section.classList.contains('is-loading') || section.classList.contains('is-playing')) return;
      const kind = section.dataset.powerdeckVideoKind;

      if (kind === 'youtube') {
        const youtubeId = section.dataset.powerdeckYoutubeId;
        const youtubeContainer = section.querySelector('.custom-powerdeck-video__youtube');
        if (!youtubeId || !youtubeContainer) return;

        section.classList.add('is-loading');
        const YT = await loadYouTubeApi();
        const player = new YT.Player(youtubeContainer, {
          videoId: youtubeId,
          playerVars: { autoplay: 1, controls: 1, playsinline: 1, rel: 0 },
          events: {
            onReady: (event) => {
              section.classList.remove('is-loading');
              section.classList.add('is-playing');
              event.target.playVideo();
            },
            onStateChange: (event) => {
              if (event.data === YT.PlayerState.ENDED) resetVideo(section);
            },
            onError: () => resetVideo(section)
          }
        });
        playerStore.set(section, player);
        return;
      }

      if (nativeVideo) {
        try {
          await nativeVideo.play();
          section.classList.add('is-playing');
        } catch (error) {
          resetVideo(section);
        }
      }
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('.custom-powerdeck-video').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.custom-powerdeck-video');
    if (section) resetVideo(section);
  });
})();
